import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { CollabScreenComponent, MessageInputService } from '@libs/collaboration';
import { map, Observable, of } from 'rxjs';

export const collabUnsentMessagesGuard: CanDeactivateFn<CollabScreenComponent> = (
  component: CollabScreenComponent,
): Observable<boolean> => {
  const messageInputService = inject(MessageInputService);

  if (component.hasPendingMessages()) {
    return component.handlePendingMessages().pipe(
      map((result) => {
        const canLeave = !!result?.confirm;
        if (canLeave) {
          messageInputService.stopDictationIfActive();
        }

        return canLeave;
      }),
    );
  }

  messageInputService.stopDictationIfActive();

  return of(true);
};
